import { profileWorkingDirectorySchema } from "../protocol/profile.js";
//#region src/schemas/daemon/local-folder-path.ts
const WINDOWS_ABSOLUTE_PATH_PATTERN = /^[A-Za-z]:[\\/]/u;
const localFolderPathSchema = profileWorkingDirectorySchema.refine((value) => value.startsWith("/") || value.startsWith("\\\\") || WINDOWS_ABSOLUTE_PATH_PATTERN.test(value), "Enter the full folder path on this computer.");
//#endregion
export { localFolderPathSchema };

//# sourceMappingURL=local-folder-path.js.map